/**
 * Lightweight event tracking utility for Rent Mitra.
 * All events are stored server-side in the `events` collection.
 * Session ID is persisted in sessionStorage (resets on tab close = new visit).
 */

export function getSessionId() {
  let sid = sessionStorage.getItem('rm_sid');
  if (!sid) {
    sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('rm_sid', sid);
  }
  return sid;
}

/**
 * @param {string} event  - e.g. 'property_view', 'search', 'contact_click'
 * @param {object} metadata - extra context: { city, category, property_type, query, ... }
 */
export function trackEvent(event, metadata = {}) {
  try {
    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: getSessionId(),
        event,
        page: window.location.pathname,
        metadata,
      }),
    }).catch(() => {});
  } catch (_) { console.error('trackEvent failed:', _); }
}
